import { Navigate, Outlet, useLocation } from "react-router-dom";
import isAuthenticated from "../../services/authService";

const RequireAuth = () => {
    const auth = isAuthenticated();
    const location = useLocation();

    if (!auth) {
        // Mémorise la destination demandée pour y revenir APRÈS connexion (deep-link).
        // sessionStorage : survit à l'étape OTP et au window.location.reload() du login,
        // contrairement au state du routeur qui serait perdu.
        const target = location.pathname + location.search;
        if (target && !target.startsWith("/connexion") && !target.startsWith("/confirm-otp")) {
            try { sessionStorage.setItem("postLoginRedirect", target); } catch { /* stockage indisponible */ }
        }
        return <Navigate to="/connexion" state={{ from: location }} replace />;
    }
    return <Outlet />;
};

export default RequireAuth;
